/**
 * Estilos compartilhados para todas as tabelas da planilha.
 * Centraliza cores, fontes e formatos para manter consistência visual.
 */
export const spreadsheetStyles = {
  // === Títulos de seção ===
  sectionTitle: {
    bg: { rgb: 'rgb(63,81,181)' },
    bl: 1,
    ht: 2,
    vt: 2,
    cl: { rgb: 'rgb(255,255,255)' },
    fs: 12,
  },

  // === Cabeçalhos de coluna ===
  header: {
    bg: { rgb: 'rgb(200,230,201)' },
    bl: 1,
    ht: 2,
    vt: 2,
    cl: { rgb: 'rgb(0,0,0)' },
  },

  // === Células bloqueadas (somente leitura) ===
  locked: {
    bg: { rgb: 'rgb(245,245,245)' },
    ht: 1,
    vt: 2,
  },

  lockedNumber: {
    bg: { rgb: 'rgb(245,245,245)' },
    ht: 2,
    vt: 2,
    n: { pattern: '0' },
  },

  lockedCurrency: {
    bg: { rgb: 'rgb(245,245,245)' },
    ht: 2,
    vt: 2,
    n: { pattern: '"R$ "#,##0.00' },
  },

  // === FORMATOS DE DATA (NOVOS) ===
  lockedDate: {
    bg: { rgb: 'rgb(245,245,245)' },
    ht: 2,
    vt: 2,
    n: { pattern: 'dd/mm/yyyy' }, // Data sem hora
  },

  lockedDateTime: {
    bg: { rgb: 'rgb(245,245,245)' },
    ht: 2,
    vt: 2,
    n: { pattern: 'dd/mm/yyyy hh:mm' }, // Data com hora
  },

  lockedDateShort: {
    bg: { rgb: 'rgb(245,245,245)' },
    ht: 2,
    vt: 2,
    n: { pattern: 'dd/mm/yy' }, // Data curta
  },

  // === Células editáveis ===
  editable: {
    bg: { rgb: 'rgb(255,255,255)' },
    ht: 1,
    vt: 2,
  },

  editableNumber: {
    bg: { rgb: 'rgb(255,255,255)' },
    ht: 2,
    vt: 2,
    n: { pattern: '0' },
  },

  editableCurrency: {
    bg: { rgb: 'rgb(255,255,255)' },
    ht: 2,
    vt: 2,
    n: { pattern: '"R$ "#,##0.00' },
  },

  // === FORMATOS DE DATA EDITÁVEIS (NOVOS) ===
  editableDate: {
    bg: { rgb: 'rgb(255,255,255)' },
    ht: 2,
    vt: 2,
    n: { pattern: 'dd/mm/yyyy' },
  },

  editableDateTime: {
    bg: { rgb: 'rgb(255,255,255)' },
    ht: 2,
    vt: 2,
    n: { pattern: 'dd/mm/yyyy hh:mm' },
  },

  // === Indicadores visuais ===
  positiveNumber: {
    bg: { rgb: 'rgb(200,230,201)' },
    ht: 2,
    vt: 2,
    bl: 1,
    n: { pattern: '0' },
  },

  negativeNumber: {
    bg: { rgb: 'rgb(255,205,210)' },
    ht: 2,
    vt: 2,
    bl: 1,
    cl: { rgb: 'rgb(198,40,40)' },
    n: { pattern: '0' },
  },

  // === Totais ===
  totalLabel: {
    bl: 1,
    ht: 3,
    vt: 2,
  },

  totalCurrency: {
    bl: 1,
    ht: 2,
    vt: 2,
    bg: { rgb: 'rgb(200,230,201)' },
    n: { pattern: '"R$ "#,##0.00' },
  },

  totalNumber: {
    bl: 1,
    ht: 2,
    vt: 2,
    bg: { rgb: 'rgb(200,230,201)' },
    n: { pattern: '0' },
  },

  // === Status / Situação (NOVO - útil para sua tabela de equipamentos) ===
  statusRented: {
    bg: { rgb: 'rgb(200,230,201)' }, // Verde
    ht: 2,
    vt: 2,
    bl: 1,
    cl: { rgb: 'rgb(27,94,32)' },
  },

  statusReserved: {
    bg: { rgb: 'rgb(255,249,196)' }, // Amarelo
    ht: 2,
    vt: 2,
    bl: 1,
    cl: { rgb: 'rgb(245,127,23)' },
  },

  statusReturned: {
    bg: { rgb: 'rgb(225,245,254)' }, // Azul claro
    ht: 2,
    vt: 2,
    bl: 1,
    cl: { rgb: 'rgb(13,71,161)' },
  },
  // === ESTILOS PARA EXCEDENTES DE CONTRATO (VERMELHO ALERTA) ===
  exchangeSectionTitle: {
    bg: { rgb: 'rgb(198,40,40)' }, // Vermelho escuro
    bl: 1,
    ht: 2,
    vt: 2,
    cl: { rgb: 'rgb(255,255,255)' },
    fs: 12,
  },
  exchangeHeader: {
    bg: { rgb: 'rgb(255,205,210)' }, // Vermelho claro (MUI error light)
    bl: 1,
    ht: 2,
    vt: 2,
    cl: { rgb: 'rgb(0,0,0)' },
  },
  exchangeTotalCurrency: {
    bl: 1,
    ht: 2,
    vt: 2,
    bg: { rgb: 'rgb(255,205,210)' },
    cl: { rgb: 'rgb(198,40,40)' }, // Texto em vermelho escuro
    n: { pattern: '"R$ "#,##0.00' },
  },
}
